import React from "react";

interface IconProps {
  className?: string;
}
export const AllGamesIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M6 2c0-1.093.907-2 2-2h4c1.093 0 2 .907 2 2v2h4a1 1 0 011 1v12a2 2 0 01-2 2H3a2 2 0 01-2-2V5a1 1 0 011-1h4V2zm6 0H8v2h4V2zM7 6a1 1 0 110 2 1 1 0 010-2zm7 1a1 1 0 10-2 0 1 1 0 002 0z"
      clip-rule="evenodd"
    ></path>
  </svg>
);
export const WebGamesIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#fff"
      d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm6.918 6h-2.305c-.247-1.199-.605-2.265-1.052-3.154A8.06 8.06 0 0118.918 8zM20 12c0 .692-.097 1.359-.263 2h-2.83a21.533 21.533 0 000-4h2.83c.166.641.263 1.308.263 2zm-8 8c-.843 0-1.949-1.481-2.555-4h5.109c-.605 2.519-1.711 4-2.554 4zm-2.892-6A18.804 18.804 0 019 12c0-.707.041-1.371.108-2h5.784c.067.629.108 1.293.108 2 0 .707-.041 1.371-.108 2H9.108zM4 12c0-.692.097-1.359.263-2h2.83a21.533 21.533 0 000 4h-2.83A7.953 7.953 0 014 12zm8-8c.843 0 1.949 1.481 2.555 4h-5.11c.606-2.519 1.712-4 2.555-4zm-3.56.846C7.993 5.735 7.635 6.801 7.388 8H5.082A8.056 8.056 0 018.44 4.846zM5.082 16h2.305c.247 1.199.605 2.265 1.052 3.154A8.06 8.06 0 015.082 16zm10.478 3.154c.447-.889.804-1.955 1.052-3.154h2.305a8.048 8.048 0 01-3.357 3.154z"
      opacity=".5"
    ></path>
  </svg>
);
export const ClientGamesIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip1)" fill="#939399">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.333 1.333H2.667c-.737 0-1.334.597-1.334 1.334v6.666c0 .737.597 1.334 1.334 1.334h10.666c.737 0 1.334-.597 1.334-1.334V2.667c0-.737-.597-1.334-1.334-1.334zM2.667 0A2.667 2.667 0 000 2.667v6.666A2.667 2.667 0 002.667 12h10.666A2.667 2.667 0 0016 9.333V2.667A2.667 2.667 0 0013.333 0H2.667z"
      ></path>
      <path d="M2.667 15a1 1 0 011-1h8.667a1 1 0 010 2H3.667a1 1 0 01-1-1zM5.334 12.667h5.333V14H5.334v-1.333z"></path>
    </g>
    <defs>
      <clipPath id="clip1">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const HomeIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M10 2L3 9v8a2 2 0 002 2h4v-6h2v6h4a2 2 0 002-2V9l-7-7z"
    />
  </svg>
);

export const GamepadIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M15.5 6h-11A4.5 4.5 0 000 10.5 4.5 4.5 0 004.5 15a4.5 4.5 0 003.5-1.69V15h4v-1.69A4.5 4.5 0 0015.5 15 4.5 4.5 0 0020 10.5 4.5 4.5 0 0015.5 6zM6 11H4v2H3v-2H1v-1h2V8h1v2h2v1zm7.5 1.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2-3c-.83 0-1.5-.67-1.5-1.5S14.67 8 15.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
    />
  </svg>
);
